import React from "react";
import { Navigate } from "react-router-dom";
import { useSchool } from "../Hooks/SchoolContext";

// Wraps a school-portal route and bounces away if the active school doesn't
// have the required module enabled (e.g. someone hits /school/dashboard
// directly via URL on a Module 1-only account). Reads from SchoolContext
// (fetched live) rather than cached localStorage, so a module change takes
// effect immediately without requiring the admin to log out and back in.
export default function RequireModule({ module, fallback = "/school/students", children }) {
    const { hasModule } = useSchool();
    if (!hasModule(module)) {
        return <Navigate to={fallback} replace />;
    }
    return children;
}
